export default {
  install (Vue) {
    // 自定义全局指令
    // Vue.directive('directiveName', {
    //   
    // })
  }
}



// WEBPACK FOOTER //
// ./src/directives/index.js